import renderMathInElement from 'katex/contrib/auto-render';
import 'katex/dist/katex.min.css';

window.addEventListener('DOMContentLoaded', () => {
  // 設問・選択肢に含まれる LaTeX（\( ... \) / \[ ... \]）を KaTeX で数式描画する。
  // OCR が数式を LaTeX で出力するため、下付き添字・分数などを崩さず表示できる。失敗時は素の文字を残す。
  renderMathInElement(document.body, {
    delimiters: [
      { left: '\\(', right: '\\)', display: false },
      { left: '\\[', right: '\\]', display: true },
    ],
    throwOnError: false,
  });

  // id 属性のグローバル変数化に依存せず、cookie 名に使う要素を明示的に取得する。
  // 過去問ページ以外でこのスクリプトが読まれても落ちないよう、要素が無ければ何もしない
  const idu = document.getElementById('idu');
  if (!idu) return;

  const pageUrl = idu.value; // ページ（問番号）の url。例: 2024_first_riron_q17
  const divisionPrefix = pageUrl.split('_q')[0]; // 例: 2024_first_riron（試験回・科目）
  const currentNumber = pageUrl.split('_q')[1] || ''; // 例: 17

  pagemove();
  refreshCookieSummary();

  // 小問 (a)(b) は同じページに複数の回答ブロックとして並ぶため、ブロックごとに独立して判定を張る
  for (const block of document.querySelectorAll('.js-answer-block')) {
    setupAnswerBlock(block);
  }

  const resetButton = document.getElementById('button_reset');
  if (resetButton) resetButton.onclick = resetDivision;

  // 1 小問ぶんの「解答する」「答えをみる」を、そのブロック内の要素に対して設定する
  function setupAnswerBlock(block) {
    const answerButton = block.querySelector('.js-button-answer');
    const kotaeButton = block.querySelector('.js-button-kotae');
    if (!answerButton) return;

    answerButton.onclick = () => {
      const misentaku = block.querySelector('.js-misentaku');
      let selectedValue = '';
      for (const radio of block.querySelectorAll('.js-radio')) {
        if (radio.checked) {
          selectedValue = radio.value;
          break;
        }
      }

      // 未選択時はここで終了
      if (selectedValue === '') {
        if (misentaku) misentaku.innerHTML = '選択されていません';
        return;
      }
      if (misentaku) misentaku.innerHTML = '';

      const correctElement = block.querySelector('.js-correct');
      const incorrectElement = block.querySelector('.js-incorrect');
      const answerValue = block.dataset.answer;
      let cookieValue;

      if (selectedValue === answerValue) {
        if (correctElement) correctElement.innerHTML = '正解';
        if (incorrectElement) incorrectElement.innerHTML = '';
        if (kotaeButton) kotaeButton.style.display = 'none';
        const answerDisplay = block.querySelector('.js-answer');
        if (answerDisplay) answerDisplay.innerHTML = '';
        cookieValue = 0;
      } else {
        if (correctElement) correctElement.innerHTML = '';
        if (incorrectElement) incorrectElement.innerHTML = '不正解';
        if (kotaeButton) kotaeButton.style.display = 'inline-block';
        cookieValue = 1;
      }
      saveCookie(block.dataset.cookieKey, cookieValue);

      // 解説を表示
      const explanation = block.querySelector('.js-exam-explanation');
      if (explanation) explanation.classList.remove('-display-none');
    };

    if (kotaeButton) {
      kotaeButton.onclick = () => {
        const answerDisplay = block.querySelector('.js-answer');
        if (answerDisplay) answerDisplay.innerHTML = block.dataset.answer;
      };
    }
  }

  // 小問単位の cookie に正誤（0=正解 / 1=不正解）を書き込む。初回解答のみ記録する既存仕様を踏襲する
  function saveCookie(name, value) {
    if (!name) return;
    const period = 1; // 有効期限日数（有効期限がないと、ブラウザを閉じた時点で cookie は無効）
    const clearTime = new Date(
      new Date().getTime() + 60 * 60 * 24 * 1000 * period
    );
    const expires = clearTime.toUTCString();
    const alreadySaved = document.cookie
      .split('; ')
      .some((cookie) => cookie.split('=')[0] === name);
    if (alreadySaved) return;

    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}`;
    refreshCookieSummary();
  }

  // 同一試験回・科目の cookie を集計し、正答率とサイドバー一覧（〇×△）を更新する。
  // 正答率は小問粒度（母数 = 解答した小問数）で数え、一覧セルは問番号ごとに小問をまとめて判定する。
  function refreshCookieSummary() {
    let total = 0;
    let corTotal = 0;
    const byNumber = {}; // 問番号 → { answered, correct }

    for (const cookie of document.cookie.split('; ')) {
      const [name, rawValue] = cookie.split('=');
      const parts = name.split('_q');
      if (parts[0] !== divisionPrefix || parts.length < 2) continue;

      // parts[1] は '17'（小問なし）か '17a'（小問）。数字部分が問番号、末尾の英字が小問
      const number = parts[1].replace(/[^0-9]/g, '');
      if (number === '') continue;

      total += 1;
      const isCorrect = rawValue === '0';
      if (isCorrect) corTotal += 1;
      byNumber[number] = byNumber[number] || { answered: 0, correct: 0 };
      byNumber[number].answered += 1;
      if (isCorrect) byNumber[number].correct += 1;
    }

    setText('percent', total === 0 ? 0 : Math.round((corTotal * 100) / total));
    setText('total', total);
    setText('cor_total', corTotal);

    // 全小問を解答し終えていないページ（未解答・一部のみ解答）の数。リセット/1問目へボタンの表示条件に使う。
    let incompleteCount = 0;
    let firstIncomplete = false;

    // judg 要素の id には表示位置ではなく実際の問題番号が入る。data-count はその問の小問数（1 or 2）。
    for (const cell of document.querySelectorAll('[id^="judg"]')) {
      const number = cell.id.replace('judg', '');
      const count = parseInt(cell.dataset.count || '1', 10);
      const stat = byNumber[number];
      const answered = stat ? stat.answered : 0;
      const correct = stat ? stat.correct : 0;

      let mark;
      if (answered === 0) {
        mark = '―'; // 未解答
      } else if (correct === count) {
        mark = '〇'; // 全小問正解
      } else if (correct === 0 && answered === count) {
        mark = '×'; // 全小問を解答して全不正解
      } else {
        mark = '△'; // 一部のみ正解 / 一部のみ解答
      }
      cell.innerHTML = mark;

      // 小問がある問題は全小問を解答して初めて「完了」とみなす（片方だけ解答は未完了扱い）
      if (answered < count) {
        incompleteCount += 1;
        if (number === '1') firstIncomplete = true;
      }
    }

    if (incompleteCount === 0) {
      const resetButton = document.getElementById('button_reset');
      if (resetButton) resetButton.style.display = 'inline-block';
    }
    if (firstIncomplete && currentNumber !== '1') {
      const toFirst = document.getElementById('button_tofirst');
      if (toFirst) toFirst.style.display = 'inline-block';
    }
  }

  function resetDivision() {
    for (const cookie of document.cookie.split('; ')) {
      const name = cookie.split('=')[0];
      if (name.split('_q')[0] === divisionPrefix) {
        document.cookie = `${name}=;max-age=0`;
      }
    }
    for (const cell of document.querySelectorAll('[id^="judg"]')) {
      cell.innerHTML = '―';
    }
    setText('percent', 0);
    setText('total', 0);
    setText('cor_total', 0);
  }

  function setText(id, value) {
    const element = document.getElementById(id);
    if (element) element.innerHTML = value;
  }

  // 前後ボタンの表示制御は _list.html.slim が算出した href に委ねる。
  // 隣の問題が無い（欠番・下書き含む）場合は href が '#' になっているので非表示にする
  function pagemove() {
    const prevButton = document.getElementById('button_prev');
    const nextButton = document.getElementById('button_next');
    if (prevButton) {
      prevButton.style.visibility =
        prevButton.getAttribute('href') === '#' ? 'hidden' : 'visible';
    }
    if (nextButton) {
      nextButton.style.visibility =
        nextButton.getAttribute('href') === '#' ? 'hidden' : 'visible';
    }
  }
});
